function appendTimestamp(payload) {
    return Object.assign(Object.assign({}, payload), { timestamp: Date.now() });
}
/**
 * Method for tracking user events
 * @param eventName string
 * @param payload object
 */
export function trackSegmentEvent(eventName, payload) {
    const { analytics } = window;
    const eventData = appendTimestamp(payload);
    if (analytics) {
        window.analytics.track(eventName, eventData);
    }
}
/**
 * Method for tracking user group events
 * @param eventName string
 * @param payload object
 */
export function trackSegmentGroupEvent(id, payload) {
    const { analytics } = window;
    const eventData = appendTimestamp(payload);
    if (analytics) {
        window.analytics.group(id, eventData);
    }
}
/**
 * Method for tracking user identify events
 * @param eventName string
 * @param payload object
 */
export function trackSegmentIdentifyEvent(id, payload) {
    const { analytics } = window;
    const eventData = appendTimestamp(payload);
    if (analytics) {
        window.analytics.identify(id, eventData);
    }
}
